const head = {
    code: 1,
    info: [
        // 前贴片广告，视频类型
        // {
        //     type: 1,
        //     materialUrl: '//avideo.ifengcdn.com/mappa/2017/01/26/c091623ce99bf65a3ccf259bacdc843a.mp4', // 广告素材地址。
        //     duration: 15, // 此段视频广告时长。角标，暂停广告为0.
        //     clickUrl:
        //         '//adclick.g.doubleclick.net/pcs/click?xai=AKAOjssY-nPNgX2OIALW2YfQ-xoj…__IESID__&v=__LOC__&xa=__ADPLATFORM__&o=https://s.click.taobao.com/e3kVtAx', // 广告跳转地址。
        //     // "vol":0,
        //     eventlog: {
        //         start: [
        //             // 开始播放监测，可有多条
        //             '//dol.deliver.ifeng.com/s?z=ifeng&c=1&l=12688',
        //             '//dol.deliver.ifeng.com/s?z=ifeng&c=1&l=12688',
        //         ],
        //         middle: [], // 播放至一半监测，角标，暂停广告为空
        //         end: [], // 播放结束监测，角标，暂停广告为空
        //         clickTrack: [], // 点击时发送，为空则不发送
        //     },
        // },
        // 前贴片广告，视频类型
        {
            materialUrl: 'https://avideo.ifengcdn.com/feather/images/72/2017/53/18/1500364405481.mp4',
            clickUrl: 'https://www.ifeng.com',
            duration: 15,
            eventlog: {
                start: [
                    'https://www.ifeng.com?start=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?start=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                middle: [
                    'https://www.ifeng.com?middle=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?middle=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                end: [
                    'https://www.ifeng.com?end=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?end=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                firstQuartile: [],
                thirdQuartile: [],
                clickTrack: [
                    'https://www.baidu.com',
                    'https://www.ifeng.com?type=click&index=1&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                ],
                vopTrack: [
                    'https://www.ifeng.com?type=vop&index=1&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                    'https://phtv.ifeng.com?type=vop&index=1&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                ],
            },
            materialType: 'video',
            type: 1,
            vol: 0.42,
        },
        // 前贴片广告，图片类型（较小）
        {
            materialUrl: 'http://c1.ifengimg.com/iamsImg/2019/02/27/73cfb45765acbd3145f71f934bc13051_w300_h250.jpg',
            clickUrl:
                'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0',
            duration: 20,
            eventlog: {
                start: [
                    'https://www.ifeng.com?start=2&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?start=2&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                middle: [
                    'https://www.ifeng.com?middle=2&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?middle=2&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                end: [
                    'https://www.ifeng.com?end=2&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?end=2&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                clickTrack: [
                    'https://www.baidu.com',
                    'https://www.ifeng.com?type=click&index=2&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                ],
                vopTrack: [
                    'https://www.ifeng.com?type=vop&index=2&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                    'https://phtv.ifeng.com?type=vop&index=2&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                ],
            },
            materialType: 'img',
            materialWidth: 300,
            materialHeight: 250,
            type: 1,
            vol: 0.42,
        },
        // 前贴片广告，图片类型（较大）
        {
            materialUrl:
                'https://x0.ifengimg.com/ucms/2022_49/9C421792CE8C84C88774B34131374FFAB5BE0BF7_size236_w1024_h683.jpg',
            clickUrl:
                'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0',
            duration: 20,
            eventlog: {},
            materialType: 'img',
            materialWidth: 1024,
            materialHeight: 683,
            type: 1,
            vol: 0.42,
        },
        // 前贴片广告，iframe类型（较大）
        {
            materialUrl: 'https://phtv.ifeng.com/channel/info',
            clickUrl:
                'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0',
            duration: 20,
            eventlog: {},
            materialType: 'iframe',
            materialWidth: 1240,
            materialHeight: 300,
            type: 1,
            vol: 0.42,
        },
    ],
};

const pause = {
    code: 1,
    info: [
        // 暂停广告，图片类型
        {
            type: 3, // 暂停
            materialUrl: 'http://c1.ifengimg.com/iamsImg/2019/02/27/73cfb45765acbd3145f71f934bc13051_w300_h250.jpg', // 广告素材地址。
            duration: 0, // 此段视频广告时长。角标，暂停广告为0.
            clickUrl:
                'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0', // 广告跳转地址。
            eventlog: {},
            materialType: 'img',
            materialWidth: 300,
            materialHeight: 250,
        },
        // 暂停广告，图片类型
        {
            type: 3, //暂停
            materialUrl: '//c1.ifengimg.com/iamsImg/2018/03/23/0a969e0dd9bd7c682e589ba11955a314_w300_h250.jpg', //广告素材地址。
            duration: 0, //此段视频广告时长。角标，暂停广告为0.
            clickUrl:
                '//iis1.deliver.ifeng.com/c?p=Z5Ak8dpljixX2bxXlYF-90ndztgDYCzN11NG89FYsj_KEKOAuZU3-W9mfsRvH66N9AoxEfHlWpyDiX1Hby9OnvXouYQrM542IRe8G30PVkt8eoMfDu0H3QS2Y8e_p46iGdyTRJXR6rktFbBRWgOWCDQoEMVtBt1M6-axm7hkI3uD9WgrdZ8Kkr6o3XHjuGKpz68GWgQR5sLiqwwzpeybzg', //广告跳转地址。
            eventlog: {
                clickTrack: [
                    'https://www.baidu.com',
                    'https://www.ifeng.com?ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__',
                ],
            },
        },
        // 暂停广告，iframe类型
        // {
        //     type: 3, // 暂停
        //     materialUrl: 'https://phtv.ifeng.com/channel/info', // 广告素材地址。
        //     duration: 0, // 此段视频广告时长。角标，暂停广告为0.
        //     clickUrl:
        //         'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0', // 广告跳转地址。
        //     eventlog: {},
        //     materialType: 'iframe',
        //     materialWidth: 1240,
        //     materialHeight: 300,
        // },
    ],
};

const end = {
    code: 1,
    // end类型和head类型除type为9以外一致
    info: [
        // {
        //     type: 9,
        //     materialUrl: '//avideo.ifengcdn.com/mappa/2017/01/26/c091623ce99bf65a3ccf259bacdc843a.mp4', // 广告素材地址。
        //     duration: 15, // 此段视频广告时长。角标，暂停广告为0.
        //     clickUrl:
        //         '//adclick.g.doubleclick.net/pcs/click?xai=AKAOjssY-nPNgX2OIALW2YfQ-xoj…__IESID__&v=__LOC__&xa=__ADPLATFORM__&o=https://s.click.taobao.com/e3kVtAx', // 广告跳转地址。
        //     // "vol":0,
        //     eventlog: {
        //         start: [
        //             // 开始播放监测，可有多条
        //             '//dol.deliver.ifeng.com/s?z=ifeng&c=1&l=12688',
        //             '//dol.deliver.ifeng.com/s?z=ifeng&c=1&l=12688',
        //         ],
        //         middle: [], // 播放至一半监测，角标，暂停广告为空
        //         end: [], // 播放结束监测，角标，暂停广告为空
        //         clickTrack: [], // 点击时发送，为空则不发送
        //     },
        // },
        {
            materialUrl: 'https://avideo.ifengcdn.com/feather/images/72/2017/53/18/1500364405481.mp4',
            clickUrl:
                'http://v-sence.gentags.net/www/delivery/ck.php?oaparams=2__bannerid=1217__zoneid=522__cb=2001726135__campaignid=408__movieid=__oadest=http://clk.gentags.net/nck/iv-5034/st-42/cr-2/oi-166833/or-3050/adv-284/pcon-0/movieid=/http://v.ifeng.com/teleplay/201510/06edd83f-21e4-491e-af6a-a2335952e597.shtml',
            duration: 15,
            eventlog: {
                start: [
                    'https://www.ifeng.com?start=0&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?start=0&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                middle: [
                    'https://www.ifeng.com?middle=0&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?middle=0&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                end: [
                    'https://www.ifeng.com?end=0&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?end=0&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                firstQuartile: [],
                thirdQuartile: [],
                clickTrack: [
                    'https://www.baidu.com',
                    'https://www.ifeng.com?type=click&index=1&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                ],
                vopTrack: [
                    'https://www.ifeng.com?type=vop&index=1&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                    'https://phtv.ifeng.com?type=vop&index=1&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                ],
            },
            materialType: 'video',
            type: 9,
            vol: 0.42,
        },
        {
            materialUrl: 'http://c1.ifengimg.com/iamsImg/2019/02/27/73cfb45765acbd3145f71f934bc13051_w300_h250.jpg',
            clickUrl:
                'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0',
            duration: 20,
            eventlog: {
                start: [
                    'https://www.ifeng.com?start=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?start=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                middle: [
                    'https://www.ifeng.com?middle=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?middle=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                end: [
                    'https://www.ifeng.com?end=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                    'https://phtv.ifeng.com?end=1&a=__ADSIZE_TYPE__&b=__VIDEO_DURATION__&c=__VIDEO_TIME__',
                ],
                firstQuartile: [],
                thirdQuartile: [],
                clickTrack: [
                    'https://www.baidu.com',
                    'https://www.ifeng.com?type=click&index=2&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                ],
                vopTrack: [
                    'https://www.ifeng.com?type=vop&index=2&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                    'https://phtv.ifeng.com?type=vop&index=2&ets=__EVENT_TIME_START__&ete=__EVENT_TIME_END__&ox=__OFFSET_X__&oy=__OFFSET_Y__&aw=__ADSPACE_W__&ah=__ADSPACE_H__&vai=__VIDEO_ACTION_ID__',
                ],
            },
            materialType: 'img',
            materialWidth: 300,
            materialHeight: 250,
            type: 9,
            vol: 0.42,
        },
        {
            materialUrl:
                'https://x0.ifengimg.com/ucms/2022_49/9C421792CE8C84C88774B34131374FFAB5BE0BF7_size236_w1024_h683.jpg',
            clickUrl:
                'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0',
            duration: 20,
            eventlog: {},
            materialType: 'img',
            materialWidth: 1024,
            materialHeight: 683,
            type: 9,
            vol: 0.42,
        },
        {
            materialUrl: 'https://phtv.ifeng.com/channel/info',
            clickUrl:
                'http://idod.ifeng.com/c?z=ifeng&la=0&si=2&cg=1&c=1&ci=2&or=20528&l=78468&bg=78468&b=138812&u=http://mfp.deliver.ifeng.com/mfp/mfpClick.do?UUIDKEY=5Lit5Zu9LeWMl-S6rOW4gi0JdglodHRwOi8vemh1amlhbi5pZmVuZy5jb20vcGNfc3RhbmQuaHRtbAktCTIzNQkxYTgxNjViMy1iZDA1LTQwYjYtODE5OS1jMmM0Yjg5MTkzMjQJMWE4MTY1YjMtYmQwNS00MGI2LTgxOTktYzJjNGI4OTE5MzI0MAk2NzM1CTIJNDQ1NwkwCS0&LandingPageURL=aHR0cHM6Ly90LmNyLW5pZWxzZW4uY29tL2Rhcj9fdD1yJnR5cGU9Y2xrJnY9MSZfaW5zdD1ubCZoYXRfY2lkPTMwMDk4MCZoYXRfcGlkPTQxOTU4OCZoYXRfYWlkPTQxNTcwNiZyPVt0aW1lc3RhbXBdJl9sPWFIUjBjSE02THk5emFHVmtaUzVxWkM1amIyMD0',
            duration: 20,
            eventlog: {},
            materialType: 'iframe',
            materialWidth: 1240,
            materialHeight: 300,
            type: 9,
            vol: 0.42,
        },
    ],
};

const error = {
    code: 0,
    info: [],
};

const noData = {
    code: 1,
    info: [],
};

const adMap = {
    head,
    pause,
    end,
    error,
    noData,
};
export const getTest = (type) => {
    // 测试错误情况
    // return adMap.error;

    // 测试无数据情况
    // return adMap.noData;

    if (adMap[type]) {
        return adMap[type];
    } else {
        return adMap.head;
    }
};
